import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';

import { ActionTypeRes} from '../patients/index.type';

const useFetchActionType = () => {
  const [actionType, setActionType] = React.useState<string[]>([]);

  const { loading: fetchingActionType, makeApiCall } = useApi({
    url: `/rtm/audit/action`,
    method: 'GET',
  });

  const  fetchActionType = async () => {
    const { response, error } = await makeApiCall<undefined,ActionTypeRes>();

    if (response?.status) {
        setActionType(response.data);
    } else {
        setActionType([]);
    }

    if (error) {
      toast.error(error.msg || 'Unable to load action types. Please refresh the page or try again later.');
    }
  };

  return {
    actionType,
   fetchActionType ,
   fetchingActionType,
  };
};

export default useFetchActionType;
